import { useEffect } from 'react';
import { useApp } from '@context/AppContext';

export default function ToastStack() {
  const { state, dispatch } = useApp();
  const { toasts } = state.ui;

  // Auto-dismiss toasts after 3 seconds
  useEffect(() => {
    if (toasts.length === 0) return;

    const latest = toasts[toasts.length - 1];
    const timer = setTimeout(() => {
      dispatch({ type: 'REMOVE_TOAST', payload: latest.id });
    }, 3000);

    return () => clearTimeout(timer);
  }, [toasts, dispatch]);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="flex items-center gap-2 px-4 py-2.5 bg-charcoal text-white text-sm font-display rounded-xl shadow-lg animate-slide-in-right pointer-events-auto"
        >
          {toast.colour && (
            <div
              className="w-2.5 h-2.5 rounded-full shrink-0"
              style={{ backgroundColor: toast.colour }}
            />
          )}
          <span>{toast.message}</span>
        </div>
      ))}
    </div>
  );
}
